import { AttachAsACopyText } from 'owa-locstrings/lib/strings/attachasacopytext.locstring.json';
import loc from 'owa-localize';
import { closeLinkContextMenu } from '../../components/LinkContextMenu';
import { LinkActionSource } from '../../types/LinkActionSource';
import { canDownloadLink } from '../canDownloadLink';
import { getProviderAndAttachLinkAsCopy } from '../getProviderAndAttachLinkAsCopy';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import { getSharingLink, SharingLinkInfo } from 'owa-link-data';

export function getAttachACopyContextMenuItem(linkId: string): IContextualMenuItem {
    const sharingLink: SharingLinkInfo = getSharingLink(linkId);

    // checks flights, policy, and content type to ensure the file is downloadable.
    if (!canDownloadLink(sharingLink)) {
        return null;
    }

    return {
        name: loc(AttachAsACopyText),
        key: 'AttachACopy',
        onClick: () => {
            logUsage('AttachmentLinkAttachAsACopy', [LinkActionSource.contextMenu]);
            closeLinkContextMenu();
            getProviderAndAttachLinkAsCopy(linkId);
        },
    };
}
